<script setup lang="ts">
import { useSchedulesTree } from '@/entities/SchedulesTree/model/model.ts'
import { computed } from 'vue'
import { VIcons } from '@/shared/ui'
import { ScheduleEditButton } from '@/features/Schedule/ScheduleEdit'
import { ScheduleCopyButton } from '@/features/Schedule/ScheduleCopy'
import { ScheduleDeleteButton } from '@/features/Schedule/ScheduleDelete'
import { useAuth } from '@/entities/Auth'

const tree = useSchedulesTree()
const { isPermissions } = useAuth()

/* Вычисляем позицию контекстного меню */
const position = computed(() => {
  return {
    top: `${tree.contextPosition.y}px`,
    left: `${tree.contextPosition.x}px`,
  }
})

/**
 * Обрабатываем клик вне объекта
 */
const outsideHandler = () => {
  tree.contextObject = null
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="tree.contextObject && isPermissions(['SСHEDULE_EDIT'])"
      :style="position"
      class="v-tree-context"
      @click="outsideHandler"
      v-click-outside="outsideHandler"
    >
      <ScheduleEditButton
        class="v-tree-context__item"
        :schedule-id="tree.contextObject.id"
        type="rename"
      >
        <VIcons type="content_cut" /> {{ $t('itf.edit') }}
      </ScheduleEditButton>

      <ScheduleCopyButton class="v-tree-context__item" :schedule-id="tree.contextObject.id">
        <VIcons type="content_copy" /> {{ $t('itf.copy') }}
      </ScheduleCopyButton>

      <ScheduleEditButton
        class="v-tree-context__item"
        :schedule-id="tree.contextObject.id"
        type="move"
      >
        <VIcons type="text_select_jump_to_end" /> {{ $t('itf.move') }}
      </ScheduleEditButton>

      <ScheduleDeleteButton class="v-tree-context__item" :schedule="tree.contextObject">
        <VIcons type="delete" /> {{ $t('itf.delete') }}
      </ScheduleDeleteButton>
    </div>
  </Teleport>
</template>
